module.exports = __webpack_public_path__ + "img/xuexiao_jiaoshi.ead6eb3c.png";